import http from '@/api/http'
import { GetChargingPointPayload, GetChargingPointResponse } from './types'

export const getChargingPoint = async (payload: GetChargingPointPayload): Promise<GetChargingPointResponse> => {
  const { stationId, chargingPointId } = payload

  const response = await http.get<GetChargingPointResponse>(
    `/stations/${stationId}/charging-points/${chargingPointId}/`,
    undefined,
    { allowForbiddenError: true }
  )
  return response.data
}
